/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ErrorMessage {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Расчётный счёт клиента для списания бонусов
 */
export interface WriteOffAccount {
  /** Номер расчётного счёта */
  accountNumber: string;

  /** Услуги, подключённые к расчётному счёту */
  writeOffAccountServices: WriteOffAccountService[];
}

/**
 * Услуга расчётного счёта клиента для списания бонусов
 */
export interface WriteOffAccountService {
  /** Код услуги */
  serviceCode: string;

  /** Наименование услуги */
  serviceName: string;

  /**
   * Количество бонусов для списания
   * @format int32
   */
  writeOffBonuses: number;
}

/**
 * Заявка на списание бонусов на услуги, подключённые к расчётным счетам клиента
 */
export interface WriteOffOrder {
  /** Расчётные счета клиента для списания бонусов банка */
  writeOffAccounts?: WriteOffAccount[];

  /** Списание бонусов на услуги партнеров */
  writeOffServices?: WriteOffPartnerService[];
}

/**
 * Списание бонусов на услуги партнёров
 */
export interface WriteOffPartnerService {
  /** Тип услуги */
  serviceType: string;

  /** Наименование услуги */
  serviceName: string;

  /**
   * Количество бонусов для списания
   * @format int32
   */
  writeOffBonuses: number;
}

/**
 * Ответ на заявку о списании бонусов
 */
export interface WriteOffOrderResponse {
  /**
   * Идентификатор заявки
   * @format uuid
   */
  id?: string;

  /** Статус заявки */
  status?: string;

  /** Результат обработки заявки */
  orderResult?: string;
}

/**
 * Расчётный счёт клиента для отмены списания бонусов
 */
export interface CancelWriteOffAccount {
  /** Номер расчётного счёта */
  accountNumber: string;

  /** Услуги, подключённые к расчётному счёту */
  cancelWriteOffAccountServices: CancelWriteOffAccountService[];
}

/**
 * Услуга расчётного счёта клиента для отиены списания бонусов
 */
export interface CancelWriteOffAccountService {
  /** Код услуги */
  serviceCode: string;

  /** Наименование услуги */
  serviceName: string;
}

/**
 * Заявка на отмену списания бонусов на услуги, подключённые к расчётным счетам клиента
 */
export interface CancelWriteOffOrder {
  /** Расчётные счета клиента для отмены списания бонусов */
  cancelWriteOffAccounts?: CancelWriteOffAccount[];

  /** Услуги клиента для отмены списания бонусов партнёров */
  cancelWriteOffPartnerServices?: CancelWriteOffPartnerService[];
}

/**
 * Отмена списания бонусов на услуги партнёров
 */
export interface CancelWriteOffPartnerService {
  /** Тип услуги */
  serviceType: string;

  /** Наименование услуги */
  serviceName: string;
}

export interface CreateServiceOrder {
  notificationType?: string;
  email?: string;
}

export interface CreateServiceResponse {
  /** @format uuid */
  id?: string;
  status?: string;
  permissions?: DocumentPermission[];
}

export interface DocumentPermission {
  /** Название операции */
  name: string;

  /** Расшифровка операции */
  desc: string;

  /** Бизнес операция согласно ролевой модели */
  operation: string;
  available?: boolean;
}

/**
 * Запрос на получение информации об операциях по бонусному счёту
 */
export interface StatementRequest {
  /**
   * Дата начала периода выписки
   * @format date
   */
  beginDate: string;

  /**
   * Дата конца периода выписки
   * @format date
   */
  endDate?: string;

  /** Тип операций в выписке */
  statementType: "ALL" | "DEBIT" | "CREDIT";
}

/**
 * Информация об операции по бонусному счёту
 */
export interface BonusOperation {
  /** Вид бонусов */
  bonusType: string;

  /** Операции по бонусному счёту по виду бонусов */
  bonusTypeOperations: Record<string, BonusTypeOperation[]>;
}

/**
 * Операция по бонусному счёту по виду бонусов
 */
export interface BonusTypeOperation {
  /** Наименование операции */
  operationName: string;

  /**
   * Сумма операции
   * @format int32
   */
  operationAmount: number;
}

/**
 * Ответ на запрос о получении информации об операциях по бонусному счёту
 */
export interface StatementResponse {
  /**
   * Дата начала периода выписки
   * @format date
   */
  beginDate: string;

  /**
   * Дата конца периода выписки
   * @format date
   */
  endDate: string;

  /** Операции по бонусному счёту */
  bonusOperations: BonusOperation[];
}

export interface ServiceOrder {
  /** @format uuid */
  id?: string;
  state?: string;

  /** @format date */
  documentDate?: string;
  notificationType?: string;
  email?: string;

  /** @format date */
  loyaltyProgramBeginDate?: string;
  isConnectingLoyaltyProgram?: boolean;
  requestDirection?: string;
  permissions?: DocumentPermission[];
}

export interface AvailableServiceResponse {
  available?: boolean;
}

/**
 * Список счетов с установленными услугами на которые можно потратить бонусы
 */
export interface LoyaltyClientAccountFacilities {
  /** Номер счёта */
  accountNumber: string;

  /** Список услуг счёта доступных для оплаты бонусами */
  loyaltyClientFacilities: LoyaltyClientFacility[];
}

/**
 * Список услуг счёта доступных для оплаты бонусами
 */
export interface LoyaltyClientFacility {
  /** Наименование услуги */
  serviceName: string;

  /** Стоимость услуги в баллах */
  serviceValue: number;

  /** Остаточная стоимость услуги для списания */
  serviceResidualValue: number;

  /** Зарезервированные баллы до списания */
  serviceReservedValue: number;

  /**
   * Дата списания баллов по услуге
   * @format date
   */
  bonusesWriteOffServiceDate: string;

  /** Код услуги */
  serviceCode: string;
}

/**
 * Информация услугах подключенных и доступных для подключения клиента
 */
export interface LoyaltyServicesResponse {
  /** Список счетов с установленными услугами на которые можно потратить бонусы */
  loyaltyClientAccountFacilities: LoyaltyClientAccountFacilities[];
}

export interface LoyaltyClientOwnNativeFacility {
  /** Наименование услуги */
  serviceName: string;

  /** Тип партнёрской услуги */
  serviceType: string;

  /** Наименование партнёра */
  partnerName: string;

  /** Наименование услуги для запроса в ЦФТ */
  serviceNameForRequest: string;

  /** Стоимость услуги в баллах */
  serviceValue: number;

  /** Наименование услуги для связки на интерфейсе */
  serviceCode: string;

  /** Ссылка на описание услуги */
  linkToDescription?: string;

  /** Используются бонусы банка */
  isBankBonuses?: boolean;

  /** Доступность услуги */
  serviceState: "AVAILABLE" | "NOT_AVAILABLE" | "CONNECTED";
}

export interface LoyaltyClientOwnNativeFacilityResponse {
  ownNativeFacilityList?: LoyaltyClientOwnNativeFacility[];
}

/**
 * Документ
 */
export interface CcbDocument {
  /** Документ */
  fields?: CcbDocument;
  type?: DocumentType;
}

/**
 * Получение ККБ конкретного документа
 */
export interface DocumentCcbResponse {
  /** ККБ документа */
  ccb?: string;

  /** Версия ККБ */
  ccbVersion?: string;

  /** Документ */
  document?: CcbDocument;
}

export interface DocumentType {
  name?: string;
  desc?: string;
}

/**
 * Получение типа подтверждения
 */
export interface ConfirmTypeResponse {
  /** Тип подтверждения */
  confirmType?: string;
}

/**
 * Информация о сегменте клиента
 */
export interface BusinessSegment {
  /** Сегмент клиента */
  businessSegment?: "MICRO" | "SMALL_OR_MEDIUM";
}

/**
 * Данные о действующем сертификате
 */
export interface ClientCertificateResponse {
  /** Серийный номер сертификата */
  serial: string;

  /** Имя эмитента сертификата (центра сертификации). */
  issuer: string;

  /** Идентификатор пользователя ДБО ЮЛ, который подписывал документ */
  userId: string;

  /** Идентификатор клиента ДБО ЮЛ */
  clientId: string;
}

export interface BonusesResponse {
  loyaltyProgramConnected?: boolean;

  /** @format date */
  loyaltyProgramBeginDate?: string;

  /** @format date */
  loyaltyProgramEndDate?: string;

  /** @format date */
  currentDate?: string;
  loyaltyProgramStatus?: string;

  /** @format int32 */
  bonuses?: number;

  /** @format int32 */
  bonusesAvailableForBank?: number;

  /** @format int32 */
  bonusesAvailableForPartners?: number;

  /** @format int32 */
  bonusesExpireForBank?: number;

  /** @format int32 */
  bonusesExpireForPartners?: number;

  /** @format int32 */
  currentMonthBonuses?: number;
}

export interface Category {
  /** Описание категории */
  categoryDesc: string;

  /**
   * Идентификатор категории
   * @format int32
   */
  categoryId: number;

  /** Изображение для категории */
  categoryImg: string;

  /** Наименование категории */
  categoryName: string;
}

/**
 * Информация о доступных категориях партнеров
 */
export interface CategoryResponse {
  categories: Category[];

  /** Количество доступных партнёров */
  partnersCount: string;
}

export interface Coupon {
  /** Скидка по промокоду */
  couponDiscount: string;

  /** Срок действия промокода */
  couponExpirationDate?: string;

  /** Наименование уровня лояльности промокода */
  couponLevelName: string;

  /** Стоимость промокода */
  couponPrice: number;

  /** Признак покупки */
  isBought: boolean;
}

export interface Partner {
  /** Описание промокода */
  couponDesc: string;

  /** Инструкция к промокоду */
  couponInstruction: string;

  /** Цель промокода */
  couponPurpose: string;
  coupons: Coupon[];

  /** Описание партнера */
  partnerDesc: string;

  /** ID партнёра */
  partnerId: number;

  /** Изображение партнера */
  partnerImg: string;

  /** Наименование партнёра */
  partnerName: string;
}

/**
 * Информация о доступных партнерах и их промокодах
 */
export interface PartnerResponse {
  partners: Partner[];
}

/**
 * Заявка на списание бонусов на услуги, подключённые к расчётным счетам клиента
 */
export interface WriteOffOrderPromocode {
  /** Списание бонусов на услуги партнеров */
  writeOffServices: WriteOffPartnerService[];
}

/**
 * Запрос на покупку промокода
 */
export interface CouponRequest {
  /** Наименование уровня лояльности промокода */
  couponLevelName: string;

  /** ID партнёра */
  partnerId: number;

  /** Заявка на списание бонусов на услуги, подключённые к расчётным счетам клиента */
  writeOffOrder: WriteOffOrderPromocode;
}

/**
 * Данные промокода
 */
export interface PromocodeShortResponse {
  /** Ссылка на сайт партнера */
  partnerLink: string;

  /** Промокод */
  promocode: string;
}

/**
 * Данные промокода
 */
export interface CouponResponse {
  /** Описание промокода */
  couponDesc: string;

  /** Скидка по промокоду */
  couponDiscount: string;

  /**
   * Срок действия промокода
   * @format date
   */
  couponExpirationDate: string;

  /** Инструкция к промокоду */
  couponInstruction: string;

  /** Наименование уровня лояльности промокода */
  couponLevelName: string;

  /** Стоимость промокода */
  couponPrice: number;

  /** Цель промокода */
  couponPurpose: string;

  /** Описание партнера */
  partnerDesc: string;

  /** ID партнёра */
  partnerId: number;

  /** Изображение партнера */
  partnerImg: string;

  /** Ссылка на сайт партнера */
  partnerLink: string;

  /** Наименование партнёра */
  partnerName: string;

  /** Промокод */
  promocode: string;
}

/**
 * Данные приобретенных промокодов
 */
export interface PromocodeResponse {
  /** Активные промокоды */
  active: CouponResponse[];

  /** Просроченные промокоды */
  expired: CouponResponse[];
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-business-bonus
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-business-bonus.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Получение статуса подключения клиента к программе лояльности «Свой Бизнес-БОНУС»
     * @name GetClientServiceState
     * @summary Получение статуса подключения клиента
     * @request POST:/api/business-bonus/v1/service/abs-cft/SendLoyaltyProgramStatusUL/request
     */
    getClientServiceState: (data: string, params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/business-bonus/v1/service/abs-cft/SendLoyaltyProgramStatusUL/request`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на списание/отмену списания бонусов по услугам
     * @name CreateWriteOffOrder
     * @summary Создание заявки на списание бонусов по услугам
     * @request POST:/api/business-bonus/v1/external/write-off
     * @secure
     */
    createWriteOffOrder: (data: WriteOffOrder, params: RequestParams = {}) =>
      this.request<WriteOffOrderResponse, ErrorMessage>({
        path: `/api/business-bonus/v1/external/write-off`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на списание/отмену списания бонусов по услугам
     * @name CancelWriteOffOrder
     * @summary Создание заявки на отмену списания бонусов по услугам
     * @request POST:/api/business-bonus/v1/external/write-off/cancel
     * @secure
     */
    cancelWriteOffOrder: (
      data: CancelWriteOffOrder,
      params: RequestParams = {}
    ) =>
      this.request<WriteOffOrderResponse, ErrorMessage>({
        path: `/api/business-bonus/v1/external/write-off/cancel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на подключения/отключение программы лояльности
     * @name CreateServiceOrder
     * @summary Создание заявки на подключение/отключение программы лояльности
     * @request POST:/api/business-bonus/v1/external/request
     * @secure
     */
    createServiceOrder: (
      data: CreateServiceOrder,
      params: RequestParams = {}
    ) =>
      this.request<CreateServiceResponse, ErrorMessage>({
        path: `/api/business-bonus/v1/external/request`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация об операциях по бонусному счёту
     * @name GetBonusStatement
     * @summary Получение информации об операциях по бонусному счету
     * @request POST:/api/business-bonus/v1/external/bonus-statement/bonus-statement
     * @secure
     */
    getBonusStatement: (data: StatementRequest, params: RequestParams = {}) =>
      this.request<StatementResponse, ErrorMessage>({
        path: `/api/business-bonus/v1/external/bonus-statement/bonus-statement`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на подключения/отключение программы лояльности
     * @name GetServiceOrder
     * @summary Получение открытую заявки на подключение/отключение программы лояльности
     * @request GET:/api/business-bonus/v1/external/request/open
     * @secure
     */
    getServiceOrder: (
      query?: { isNeedForceSignUpdate?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<ServiceOrder, ErrorMessage>({
        path: `/api/business-bonus/v1/external/request/open`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на подключения/отключение программы лояльности
     * @name CheckAvailableServiceForClient
     * @summary Проверка доступности создания заявки программы лояльности
     * @request GET:/api/business-bonus/v1/external/request/available
     * @secure
     */
    checkAvailableServiceForClient: (params: RequestParams = {}) =>
      this.request<AvailableServiceResponse, ErrorMessage>({
        path: `/api/business-bonus/v1/external/request/available`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация о услугах программы лояльности
     * @name GetLoyaltyServices
     * @summary Получение информации о доступных услугах, которые можно оплатить бонусами по счетам
     * @request GET:/api/business-bonus/v1/external/facility
     * @secure
     */
    getLoyaltyServices: (
      query: { fromExtSystem: boolean },
      params: RequestParams = {}
    ) =>
      this.request<LoyaltyServicesResponse, ErrorMessage>({
        path: `/api/business-bonus/v1/external/facility`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация о услугах программы лояльности
     * @name GetLoyaltyOwnNative
     * @summary Получение информации о доступных услугах Своего Родного, которые можно оплатить бонусами
     * @request GET:/api/business-bonus/v1/external/facility/own-native
     * @secure
     */
    getLoyaltyOwnNative: (params: RequestParams = {}) =>
      this.request<LoyaltyClientOwnNativeFacilityResponse, ErrorMessage>({
        path: `/api/business-bonus/v1/external/facility/own-native`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из МС Подтверждения
     * @name GetDocumentCcb
     * @summary Получение ККБ Заявки на подключение программы лояльности
     * @request GET:/api/business-bonus/v1/external/confirmation/document-ccb
     * @secure
     */
    getDocumentCcb: (query: { orderId: string }, params: RequestParams = {}) =>
      this.request<DocumentCcbResponse, ErrorMessage>({
        path: `/api/business-bonus/v1/external/confirmation/document-ccb`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из МС Подтверждения
     * @name GetClientConfirmType
     * @summary Получение типа подтверждения для клиента
     * @request GET:/api/business-bonus/v1/external/confirmation/confirm-type
     * @secure
     */
    getClientConfirmType: (params: RequestParams = {}) =>
      this.request<ConfirmTypeResponse, ErrorMessage>({
        path: `/api/business-bonus/v1/external/confirmation/confirm-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение информации о клиенте
     * @name GetClientBusinessSegment
     * @summary Получение сегмента клиента
     * @request GET:/api/business-bonus/v1/external/client/segment
     * @secure
     */
    getClientBusinessSegment: (params: RequestParams = {}) =>
      this.request<BusinessSegment, ErrorMessage>({
        path: `/api/business-bonus/v1/external/client/segment`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сертификаты клиента
     * @name GetClientActiveCertificate
     * @summary Получение доступного сертификата клиента
     * @request GET:/api/business-bonus/v1/external/certificate/client-active-certificate
     * @secure
     */
    getClientActiveCertificate: (params: RequestParams = {}) =>
      this.request<ClientCertificateResponse, ErrorMessage>({
        path: `/api/business-bonus/v1/external/certificate/client-active-certificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация о статусе и бонусах клиента
     * @name GetBonusesInfo
     * @summary Получение информации о статусе и бонусах клиента
     * @request GET:/api/business-bonus/v1/external/bonus
     * @secure
     */
    getBonusesInfo: (
      query: { fromExtSystem: boolean },
      params: RequestParams = {}
    ) =>
      this.request<BonusesResponse, ErrorMessage>({
        path: `/api/business-bonus/v1/external/bonus`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с промокодами клиента
     * @name GetCategories
     * @summary Получение доступных категорий партнеров
     * @request GET:/api/business-bonus/v1/external/loyaltyback/category
     * @secure
     */
    getCategories: (params: RequestParams = {}) =>
      this.request<CategoryResponse, ErrorMessage>({
        path: `/api/business-bonus/v1/external/loyaltyback/category`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с промокодами клиента
     * @name GetPartnersInformation
     * @summary Получение доступных партнеров в рамках категории
     * @request GET:/api/business-bonus/v1/external/loyaltyback/partners
     * @secure
     */
    getPartnersInformation: (
      query?: { categoryId?: number },
      params: RequestParams = {}
    ) =>
      this.request<PartnerResponse, ErrorMessage>({
        path: `/api/business-bonus/v1/external/loyaltyback/partners`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с промокодами клиента
     * @name GetCoupon
     * @summary Покупка промокода
     * @request POST:/api/business-bonus/v1/external/loyaltyback/coupon/purchase
     * @secure
     */
    getCoupon: (data: CouponRequest, params: RequestParams = {}) =>
      this.request<PromocodeShortResponse, ErrorMessage>({
        path: `/api/business-bonus/v1/external/loyaltyback/coupon/purchase`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с промокодами клиента
     * @name GetBoughtPromocodes
     * @summary Получение активных промокодов клиента
     * @request GET:/api/business-bonus/v1/external/loyaltyback/promocodes
     * @secure
     */
    getBoughtPromocodes: (params: RequestParams = {}) =>
      this.request<PromocodeResponse, ErrorMessage>({
        path: `/api/business-bonus/v1/external/loyaltyback/promocodes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с промокодами клиента
     * @name GetImage
     * @summary Получение логотипов партнеров и категорий
     * @request GET:/api/business-bonus/v1/external/loyaltyback/images/{resourceType}/{resourceId}
     * @secure
     */
    getImage: (
      resourceType: string,
      resourceId: number,
      params: RequestParams = {}
    ) =>
      this.request<string, ErrorMessage>({
        path: `/api/business-bonus/v1/external/loyaltyback/images/${resourceType}/${resourceId}`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
}

export const api = new Api();
